import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, startWith, switchMap} from 'rxjs/operators';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {AsyncPipe, CommonModule} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {CatalogsService, CityResource, FieldResource} from '../../core/modules/openapi';
import {MatOptionSelectionChange} from '@angular/material/core';

@Component({
  selector: 'app-city-search',
  imports: [FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    AsyncPipe, CommonModule],
  templateUrl: './city-search.component.html',
  standalone: true,
  styleUrl: './city-search.component.sass'
})
export class CitySearchComponent implements OnInit {
  @Input() maxCities = 10;
  field: FieldResource;
  group: FormGroup;
  cityCtrl : FormControl;
  filteredCities: Observable<CityResource[]>;
  validSelection = false;
  selectedCity: CityResource;

  constructor(private catalogsService: CatalogsService) {

  }

  ngOnInit(): void {
    this.cityCtrl = new FormControl({ value: '', disabled: !this.field.enabled });
    this.filteredCities = this.cityCtrl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(city => (city ? this._filterCities(city) : [])),
    );
    if (this.field.value) {
      this._filterCities(this.field.value as string)
        .subscribe(result => this.cityCtrl.setValue(this.getDisplay(result[0])));
    }
  }

  private _filterCities(value: string): Observable<CityResource[]> {
    return this.catalogsService.searchCities(value);
  }

  public checkCity() {
    if (this.selectedCity) {
      const selectedDisplay = this.getDisplay(this.selectedCity);
      if (this.cityCtrl.value !== selectedDisplay) {
        this.cityCtrl.setValue('');
      } else {
        this.field.value = this.selectedCity.id || '';
      }
    }
  }

  citySelected($event: MatOptionSelectionChange, city: CityResource) {
    if($event.isUserInput) {
      this.selectedCity = city;
      this.field.value = city.id||'';
      this.group.controls[this.field.name]?.setValue(this.field.value);
    }
  }

  getDisplay(city: CityResource): any {
    return city.name + ' - ' + city.stateName;
  }
}
